import { isNil } from "lodash";
import { RgbaColor } from "react-colorful";



export function getcCssRgbaColor(color: RgbaColor | undefined) {

    if (isNil(color))
        return "";
    return "rgba(" + color.r + "," + color.g + "," + color.b + "," + color.a + ")";
}